import * as CubiqTS from "../../../shared/cubiq-model-multi-asset";
import { FilterOrderTypes } from "../../../shared/cubiq-services";

const UNIX_EPOC = 1;
const ACTIVE_FILTER_ID = -2000;
const FILLED_FILTER_ID = -3000;

export const VIEW_FILTER_FILTER_IDS = new Set<number>([ACTIVE_FILTER_ID, FILLED_FILTER_ID]);

// see also BfxBlotterFilter.transform in bfx-blotter-filter.service.ts
export const ACTIVE_BM_VIEW_FILTER: CubiqTS.BlotterFilterImpl = Object.assign(
  new CubiqTS.BlotterFilterImpl(),
  {
    filterId: CubiqTS.Long.fromValue(ACTIVE_FILTER_ID),
    filterName: "Active State",
    createdBy: "System",
    createDateVal: UNIX_EPOC,
    lastUpdateDts: UNIX_EPOC,
    entryUserId: CubiqTS.Long.fromValue("-1"),
    createDate: "01/01/1970 00:00:00",
    isSystemFilter: true,
    conditions: [],
    queryGroup: Object.assign(new CubiqTS.QueryGroupImpl(), {
      groups: [
        Object.assign(new CubiqTS.QueryGroupImpl(), {
          groups: [],
          rules: [
            {
              values: [
                CubiqTS.OrderState[CubiqTS.OrderState.FILLED],
                CubiqTS.OrderState[CubiqTS.OrderState.EXPIRED],
                CubiqTS.OrderState[CubiqTS.OrderState.REJECTED],
                CubiqTS.OrderState[CubiqTS.OrderState.CANCELLED],
              ],
              field: "orderState",
              operator: CubiqTS.Operator.NotIn,
            },
          ],
          condition: CubiqTS.Condition.AND,
        }),
        Object.assign(new CubiqTS.QueryGroupImpl(), {
          rules: [
            Object.assign(new CubiqTS.QueryRuleImpl(), {
              values: ["CANCELLED", "EXPIRED", "FILL_EXPIRED"],
              field: "orderState",
              operator: CubiqTS.Operator.In,
            }),
            Object.assign(new CubiqTS.QueryRuleImpl(), {
              values: [FilterOrderTypes[FilterOrderTypes.BMARK]],
              field: "requestedOrderType",
              operator: CubiqTS.Operator.NotIn,
            }),
            Object.assign(new CubiqTS.QueryRuleImpl(), {
              values: ["0"],
              field: "executedQty",
              operator: CubiqTS.Operator.Equal,
            }),
          ],
          condition: CubiqTS.Condition.AND,
        }),
      ],
      rules: [],
      condition: CubiqTS.Condition.OR,
    }),
  },
);

// see also BfxBlotterFilter.transform in bfx-blotter-filter.service.ts
export const FILLED_BM_VIEW_FILTER = Object.assign(new CubiqTS.BlotterFilterImpl(), {
  filterId: CubiqTS.Long.fromValue(FILLED_FILTER_ID),
  filterName: "Filled State",
  createdBy: "System",
  createDateVal: UNIX_EPOC,
  createDate: "01/01/1970 00:00:00",
  lastUpdateDts: UNIX_EPOC,
  entryUserId: CubiqTS.Long.fromValue("-1"),
  isSystemFilter: true,
  conditions: [],
  queryGroup: Object.assign(new CubiqTS.QueryGroupImpl(), {
    groups: [
      Object.assign(new CubiqTS.QueryGroupImpl(), {
        groups: [],
        rules: [
          Object.assign(new CubiqTS.QueryRuleImpl(), {
            values: ["FILLED"],
            field: "orderState",
            operator: CubiqTS.Operator.In,
          }),
        ],
        condition: CubiqTS.Condition.AND,
      }),
      Object.assign(new CubiqTS.QueryGroupImpl(), {
        groups: [],
        rules: [
          Object.assign(new CubiqTS.QueryRuleImpl(), {
            values: ["CANCELLED", "EXPIRED", "FILL_EXPIRED"],
            encoder: {
              baseEncoder: {},
            },
            field: "orderState",
            operator: CubiqTS.Operator.In,
          }),
          Object.assign(new CubiqTS.QueryRuleImpl(), {
            values: [FilterOrderTypes[FilterOrderTypes.BMARK]],
            field: "requestedOrderType",
            operator: CubiqTS.Operator.NotIn,
          }),
          Object.assign(new CubiqTS.QueryRuleImpl(), {
            values: ["0"],
            field: "executedQty",
            operator: CubiqTS.Operator.Greater,
          }),
        ],
        condition: CubiqTS.Condition.AND,
      }),
    ],
    rules: [],
    condition: CubiqTS.Condition.OR,
  }),
});
